import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { NumberInput } from "MODULES/shared/components/Forms";

const handleKeyPress = event => {
  if (event.keyCode === 38 || event.keyCode === 40) {
    event.preventDefault();
  }
};

const defaultInputProps = {
  min: 0,
  step: "0.01",
  onKeyDown: handleKeyPress
};

export default function CurrencyField({ ...props }) {
  const { inputProps, ...rest } = props;

  return (
    <Field
      type="number"
      addon={<i className="fa fa-dollar" />}
      className="text-right"
      component={NumberInput}
      inputProps={Object.assign({}, defaultInputProps, inputProps)}
      {...rest}
    />
  );
}

CurrencyField.defaultProps = {
  inputProps: {}
};

CurrencyField.propTypes = {
  inputProps: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/CurrencyField/CurrencyField.jsx